import type { QueryClient } from "@tanstack/react-query";
import { prefetchLocations } from "@/lib/utils/prefetch/prefetchLocations";
import { prefetchTenantContentSettings } from "@/lib/utils/prefetch/prefetchTenantContentSettings";
import { prefetchTenantGetPublic } from "@/lib/utils/prefetch/prefetchTenantGetPublic";
import { prefetchTenantLogoPublic } from "@/lib/utils/prefetch/prefetchTenantLogoPublic";

/**
 * Client-safe fallback. Public pages should call `seedMicrositePublicBundle`
 * so tenant/CMS/logo are fetched once per request via React cache.
 */
export async function prefetchMicrositePublicBundle(
  queryClient: QueryClient,
  tenantId: number,
): Promise<void> {
  await Promise.all([
    prefetchTenantContentSettings(queryClient, tenantId),
    prefetchTenantGetPublic(queryClient, tenantId),
    prefetchTenantLogoPublic(queryClient, tenantId),
    prefetchLocations(queryClient),
  ]);
}
